import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import withProfileImageUploader from 'mixins/with-profile-image-uploader';

function coverUploader() {
    this.defaultAttrs({
        eventPrefix: 'uiCover',
        backupUrl: '',
        previewImageWidth: 2000,

        containerSelector: '[data-cover-image]',
        originalImageSelector: '[data-cover-image-display]',
        canvasSelector: '[data-cover-image-preview-canvas]',
        uploaderSelector: '[data-cover-uploader]',
        saveButtonSelector: '[data-cover-image-save-button]',
        saveButtonInnerSelector: '[data-cover-image-save-button-inner]',
        saveButtonLabelSelector: '[data-cover-image-save-button-label]',
        cancelButtonSelector: '[data-cover-image-cancel-button]',
        editButtonSelector: '[data-cover-image-edit-button]',
        confirmEditWrapperSelector: '[data-cover-image-confirm-edit]',
        errorMessageSelector: '[data-image-alert]',
        errorMessageBodySelector: '[data-image-alert-body]',
        uploaderTemplateSelector: '[data-cover-uploader-template]',
    });

    this.after('initialize', function() {
        // UI interaction events
        this.on('click', {
            saveButtonSelector: this.uploadSelectedImage,
            cancelButtonSelector: this.cancelSelectedImage,
        });

        // Set preview image to DOM when canvas was drawn
        this.on('uiCoverDrawnOnCanvas', this.setBackgroundUrl);

        // Image selected for preview
        this.on('uiCoverSubmittedToUploader', this.drawThumbnailOnCanvas);
        this.on('uiCoverSubmittedToUploader', this.showConfirmWrapper);
        this.on('uiCoverSubmittedToUploader', this.showOverlay);
        this.on('uiCoverSubmittedToUploader', this.ensureCoverImageVisible);

        // Image upload canceled (CANCEL buttons)
        this.on('uiCoverUploadCanceled', this.setBackgroundUrl);
        this.on('uiCoverUploadCanceled', this.hideConfirmWrapper);
        this.on('uiCoverUploadCanceled', this.hideOverlay);
        this.on('uiCoverUploadCanceled', this.restoreOriginalVisibility);

        // Image upload started (SAVE buttons)
        this.on('uiCoverUploadStarted', this.disableSaveButton);
        this.on('uiCoverUploadStarted', this.disableCancelButton);

        // Automatic image upload started (e.g. old browsers)
        this.on('uiCoverAutomaticUploadStarted', this.disableEditButton);

        // Image upload complete
        this.on('uiCoverUploadComplete', this.hideOverlay);
        this.on('uiCoverUploadComplete', this.hideConfirmWrapper);
        this.on('uiCoverUploadComplete', this.enableSaveButton);
        this.on('uiCoverUploadComplete', this.enableCancelButton);
        this.on('uiCoverUploadComplete', this.enableEditButton);
        this.on('uiCoverUploadComplete', this.setBackgroundUrl);

        // Upload failed
        this.on('uiCoverUploadFailed', this.showErrorMessage);
        this.on('uiCoverUploadFailed', this.setBackgroundUrl);

        // Set backup url for orignal cover-image
        this.attr.backupUrl = this.select('originalImageSelector').attr(
            'data-cover-image-backup-url'
        );

        // Initialize Fineuploader
        this.initializeUploader();
    });

    this.ensureCoverImageVisible = function() {
        this.attr.originallyVisible = this.select('containerSelector').attr('data-has-cover-image');
        this.select('containerSelector').attr('data-has-cover-image', 'true');
    };

    this.restoreOriginalVisibility = function() {
        this.select('containerSelector').attr('data-has-cover-image', this.attr.originallyVisible);
    };
}

export default defineComponent(coverUploader, withProfileImageUploader);



// WEBPACK FOOTER //
// ./src/js/component_ui/cover-uploader.js